import {
  InputNumber,
  Button,
  Select,
  Option,
  OptionGroup,
  Popover,
  Checkbox,
  Icon,
  Row,
  Col,
  Tabs,
  TabPane,
  Input,
  Pagination,
  MessageBox,
  Message,
  Dialog,
  Form,
  FormItem,
  Tooltip,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  Carousel,
  CarouselItem,
  Alert,
  Cascader,
  Breadcrumb,
  BreadcrumbItem,
  Image,
  Drawer,
  Collapse,
  CollapseItem,
  Upload
} from "element-ui";
export default {
  install(Vue) {
    Vue.component(Input.name, Input);
    Vue.component(InputNumber.name, InputNumber);
    Vue.component(Button.name, Button);
    Vue.component(Select.name, Select);
    Vue.component(Option.name, Option);
    Vue.component(OptionGroup.name, OptionGroup);
    Vue.component(Popover.name, Popover);
    Vue.component(Checkbox.name, Checkbox);
    Vue.component(Row.name, Row);
    Vue.component(Col.name, Col);
    Vue.component(Icon.name, Icon);
    Vue.component(Tabs.name, Tabs);
    Vue.component(TabPane.name, TabPane);
    Vue.component(Pagination.name, Pagination);
    Vue.component(MessageBox.name, MessageBox);
    Vue.component(Message.name, Message);
    Vue.component(Dialog.name, Dialog);
    Vue.component(Form.name, Form);
    Vue.component(FormItem.name, FormItem);
    Vue.component(Tooltip.name, Tooltip);
    Vue.component(Table.name, Table);
    Vue.component(TableColumn.name, TableColumn);
    Vue.component(DatePicker.name, DatePicker);
    Vue.component(TimeSelect.name, TimeSelect);
    Vue.component(Carousel.name, Carousel);
    Vue.component(CarouselItem.name, CarouselItem);
    Vue.component(Alert.name, Alert);
    Vue.component(Cascader.name, Cascader);
    Vue.component(Breadcrumb.name, Breadcrumb);
    Vue.component(BreadcrumbItem.name, BreadcrumbItem);
    Vue.component(Image.name, Image);
    Vue.component(Drawer.name, Drawer);
    Vue.component(Collapse.name, Collapse);
    Vue.component(CollapseItem.name, CollapseItem);
    Vue.component(Upload.name, Upload);
    Vue.prototype.$message = Message;
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
  },
};



// WEBPACK FOOTER //
// ./src/utils/elementUi.js